export default "__VITE_ASSET__DIkYeQOc__"